export default __webpack_public_path__ + "images/bg_cert.jpg";